import { useCallback } from 'react';

import { LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

import { PROMO_LINK } from 'shared/constants/links';
import { useGuideAnalytics } from 'shared/hooks';
import { SMB_FIRST_TIME_BANNER_NAME } from 'shared/utils/tracking';

import * as styles from './styles.css';

export const FirstTimeBanner: React.FC = () => {
  const device = useDeviceType();
  const { trackPlaceAdClick } = useGuideAnalytics();

  const btnSize = device === 'phone' ? 'M' : 'L';

  const handleButtonClick = useCallback((): void => {
    trackPlaceAdClick(SMB_FIRST_TIME_BANNER_NAME);
  }, [trackPlaceAdClick]);

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['text-block']}>
        <div className={styles['title']}>Впервые на Циан?</div>
        <div className={styles['description']}>Дарим 1 000 бонусов новым пользователям</div>
      </div>
      <div className={styles['btn']}>
        <Theme theme="colored">
          <LinkButton
            href={PROMO_LINK}
            target="_blank"
            rel="noopener noreferrer"
            fullWidth
            size={btnSize}
            onClick={handleButtonClick}
          >
            Разместить объявление
          </LinkButton>
        </Theme>
      </div>
    </div>
  );
};
